<template>
    <span class="u-reset snake-pattern">
        <ui-icon symbol="snake-pattern"/>
    </span>
</template>

<script>
    import UiIcon from '@dreipol/vue-ui/src/components/icon/icon.vue';

    export default {
        components: {
            UiIcon,
        },
        props: {
        },
    };
</script>
